import React from 'react';
import PlanDeComMonthCard from './PlanDeComMonthCard';

const PlanDeComYearGrid = ({ lignes = [], onOpenMonth, locked = false }) => (
  <div className="kkp-pdc-year-grid-wrap">
    <div className="kkp-pdc-year-grid">
      {lignes.map((ligne) => (
        <PlanDeComMonthCard
          key={ligne.ordre}
          ligne={ligne}
          locked={locked}
          onOpen={onOpenMonth}
        />
      ))}
    </div>
  </div>
);

export default PlanDeComYearGrid;
